import { clientNeoActivite, clientNeoActiviteWS } from "@newrai/api-clients";
import { Header } from "@newrai/neonumy-ui";
import { Layout } from "antd";
import { useAuth } from "config/auth/useAuth";
import { routes } from "config/routes";
import { default as settings } from "config/settings";
import useStore from "config/store";
import useCompanySelection from "hooks/useCompanySelection";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Logo from "resources/images/logo.svg?react";

function HeaderWrapper(): React.ReactElement {
  const { companyID } = useParams();
  const navigate = useNavigate();
  const userData = useStore(state => state.userData);
  const setCompanySelected = useStore(state => state.setCompanySelected);
  const setAccountingFirmSelected = useStore(state => state.setAccountingFirmSelected);
  const setCompanyData = useStore(state => state.setCompanyData);
  const resetCompanySelect = useStore(state => state.resetCompanySelect);
  const companySelected = useStore(state => state.companySelected);
  const accountingFirmSelected = useStore(state => state.accountingFirmSelected);
  const { saveCompany } = useCompanySelection();
  const { logout } = useAuth();

  const canUpdateCompany =
    userData?.permissions &&
    userData?.permissions?.find((item: string) => item === "dashboard.can-display-companies");

  const canNavigateWithCompany = userData?.permissions?.includes(
    "neoauth.can-navigate-with-company",
  );

  const userIsClient = ["client"].includes(userData?.userCategory?.slug);

  const partialUserData = {
    firstName: userData?.firstName ?? "",
    lastName: userData?.lastName ?? "",
    email: userData?.email ?? "",
    category: userData?.userCategory?.slug ?? "",
    isNewraiUser: userData?.isNewraiUser ?? false,
  };

  return (
    <Layout>
      <Header
        appLogo={
          <button
            style={{ cursor: "pointer", background: "none", border: "none", padding: 0 }}
            onClick={() => {
              resetCompanySelect();
              navigate("/");
            }}
          >
            <Logo style={{ height: "30px" }} />
          </button>
        }
        appName="NeoScan-Pro"
        userData={partialUserData}
        companySelected={companySelected}
        accountingFirmSelected={accountingFirmSelected}
        userAvatar={{
          profileHref: `${settings.dashboard}account/profile`,
          handleLogout: logout,
        }}
        notifications={{
          neoActiviteClientHttp: clientNeoActivite,
          neoActiviteClientWS: clientNeoActiviteWS,
        }}
        selectCompanyOptions={{
          isEditable: true,
          companyOnly: userIsClient,
          handleOnSelectCompany: (companyData: unknown) =>
            saveCompany(companyData as CompaniesWithAccountingFirm),
          handleOnSelectAccountingFirm: (accountingFirm: unknown) => {
            const value = accountingFirm as AccountingFirm;
            setCompanySelected(undefined);
            setCompanyData(undefined);
            setAccountingFirmSelected({ id: value.id, name: value.name });
            routes.navigate("/");
          },
        }}
        {...(canNavigateWithCompany && {
          appsUrlParams: {
            companyId: companySelected?.id,
            accountingFirmId: accountingFirmSelected?.id,
          },
        })}
        {...(companyID &&
          canUpdateCompany && {
            dashboardCompanyUrl: `${settings.dashboard}companies/${companyID}/general/general-info`,
          })}
      />
    </Layout>
  );
}

const HeaderWrapperMemo = React.memo(HeaderWrapper);

export default HeaderWrapperMemo;
